import React from 'react';
import { QuestionnaireView } from './useGetLastQuestionnaireByPatientCodexId';
import {
  BLOOD_PRESSURE_QUESTION_ID,
  KIDNEY_STONES_QUESTION_ID,
  MED_ALLERGENS_QUESTION_ID,
} from 'components/dynamicQuestionnaire/utils/constants';

export interface QuestionnaireBlockProps {
  title: string;
  questionnaire: QuestionnaireView[];
}

interface BloodPressureAnswer {
  inputLabel: string;
  response: string;
}

const BloodPressureAnswerBlock: React.FC<QuestionnaireView> = ({
  title,
  answer,
}) => {
  if (Array.isArray(answer)) {
    const texts = (answer as BloodPressureAnswer[]).map(
      ({ inputLabel, response }) => `${inputLabel}: ${response}`,
    );

    return (
      <div className="self-stretch inline-flex flex-col justify-start items-start gap-2.5">
        <div className="self-stretch justify-start text-neutral-800 text-base font-semibold leading-snug">
          {title}
        </div>
        <div className="inline-flex self-stretch gap-2.5 justify-start text-med-gray-3 text-base font-medium leading-snug">
          {texts.map((text) => (
            <div key={text}>{text}</div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="self-stretch inline-flex flex-col justify-start items-start gap-2.5">
      <div className="self-stretch justify-start text-neutral-800 text-base font-semibold  leading-snug">
        {title}
      </div>
      <div className="self-stretch justify-start text-med-gray-3 text-base font-medium  leading-snug">
        {answer as string}
      </div>
    </div>
  );
};

export const Block: React.FC<QuestionnaireView> = ({
  title,
  answer,
  questionID,
}) => {
  const text =
    typeof answer === 'string' ? answer : (answer as string[]).join(', ');

  if (+questionID === BLOOD_PRESSURE_QUESTION_ID) {
    return (
      <BloodPressureAnswerBlock
        title={title}
        questionID={questionID}
        answer={answer}
      />
    );
  }

  if (+questionID === KIDNEY_STONES_QUESTION_ID) {
    return null;
  }

  if (+questionID === MED_ALLERGENS_QUESTION_ID) {
    return null;
  }

  return (
    <div className="self-stretch inline-flex flex-col justify-start items-start gap-2.5">
      <div className="self-stretch justify-start text-neutral-800 text-base font-semibold  leading-snug">
        {title}
      </div>
      <div className="self-stretch justify-start text-med-gray-3 text-base font-medium  leading-snug">
        {text}
      </div>
    </div>
  );
};

const QuestionnaireBlock: React.FC<QuestionnaireBlockProps> = ({
  questionnaire = [],
  title,
}) => {
  return (
    <div className="flex flex-col gap-5">
      <div className="self-stretch justify-start text-neutral-800 text-xl font-semibold leading-normal">
        {title}
      </div>
      {questionnaire
        .sort((a, b) => +a.questionID - +b.questionID)
        .map((questionnaire) => (
          <Block key={questionnaire.questionID} {...questionnaire} />
        ))}
    </div>
  );
};

export default QuestionnaireBlock;
